import { Config } from "../../../api/config";
export var JobCardKeys = {
    Parts: "JobCardParts",
    Labour: "JobCardLabour",
    ReworkHistory: 'ReworkHistory',
    Configurations: 'getConfigurations',
    HeaderTechnicianAtLineLevelAutomatically: "HeaderTechnicianAtLineLevelAutomatically",
    IsLabourAutomaticallyStarted: "IsLabourAutomaticallyStarted",
    RestrictUserEditingDate: "RestrictUserEditingDate",
    RestrictUserEditingReworkStartDate: "RestrictUserEditingReworkStartDate",
    RestrictReverseSelectionLaborStatus: "RestrictReverseSelectionLaborStatus",
    ToComplateLabourWithoutIssuingPart: "ToComplateLabourWithoutIssuingPart",
    ToAllowUserEditLineLEevelJobCard: "ToAllowUserEditLineLEevelJobCard",
    ToAllowUserRemoveLineLEevelJobCard: "ToAllowUserRemoveLineLEevelJobCard",
    EditValueResubmitFinalInspection: "EditValueResubmitFinalInspection",
    LineLevelValueResubmittedForFinalInsepection: "LineLevelValueResubmittedForFinalInsepection",
    RemovedLineLevelValueSubmittedForFinalInspection: "RemovedLineLevelValueSubmittedForFinalInspection",
    UpdateJobCardLabourStatus: 'UpdateJobCardLabourStatus',
    UpdateLabourList: 'UpdateLabourList',
    DeleteLabour: 'DeleteLabour',
    UpsertPartLabour: 'UpsertPartLabour',
    CustomerVoice: 'CustomerVoice',
    AllJobCardData: 'AllJobCardData',
    NatureOfAccidentList: 'NatureOfAccidentList',
    InsuranceProviderList: 'InsuranceProviderList',
    CoverageTypeList: 'CoverageTypeList',
    LossTypeList: 'LossTypeList',
    WorkDistributionList: 'WorkDistributionList',
    UpsertWorkDistributionKey: 'UpsertWorkDistributionKey',
    LabourStatusList: 'LabourStatusList',
    SupplierList: 'SupplierList',
    DefectList: 'DefectList',
    WorkPurchaseOrderList: 'WorkPurchaseOrderList',
    Create: 'CreateJobCard',
    Update: 'UpdateJobCard',
    Get: 'jobCardData',
    WarrantyGet: 'warrantyListGetById',
    DisableSubmit: 'disableSubmitJC',
    ValidateQty: 'validateQty'
};
export var RatioBillingConstant = {
    AllowType: 'Fixed',
    Amount: 'Amount',
    Percent: 'Percent',
    Both: 'Both'
};
export var getPartsbyJobCard = "".concat(Config.baseURL, "JobCardDetail/PartsByJC");
export var getLabourbyJobCard = "".concat(Config.baseURL, "JobCardDetail/LabourbyJobCard");
export var reworkHistoryAPI = "".concat(Config.baseURL, "JobCardsReworkHistory/List");
export var getConfigurationsAPI = "".concat(Config.baseURL, "OrganizationModulesItemSetting/GetByKeys");
export var updateJobCardLabourStatusAPI = "".concat(Config.baseURL, "JobCardDetail/UpdateStatusByJobs");
export var UpdateLabourListAPI = "".concat(Config.baseURL, "JobCardDetail/UpdateLabourList");
export var deleteLabourAPI = "".concat(Config.baseURL, "JobCardDetail/DeleteJobCardDetail");
export var JobCardDetailsURL = function (id) { return "".concat(Config.baseURL, "JobCard/").concat(id, "/Get"); };
export var modifyJobCardURL = "".concat(Config.baseURL, "JobCard/ModifyJCDetails");
//Update job Card details URLs
export var upsertPartLabourURL = "".concat(Config.baseURL, "JobCardDetail/UpsertPartAndLabour");
export var upsertWarrantyDetailsURL = "".concat(Config.baseURL, "WarrantyDetail/Upsert");
export var upsertCustomerVoiceURL = "".concat(Config.baseURL, "JobCardCustomerVoiceToJobItem/Upsert");
// Warranty APIs
export var getWarrantyListByJobCardId = "".concat(Config.baseURL, "WarrantyDetail/GetWarrantyDetailsbyJobcardId");
export var getWarrantyPartListByJobCardId = "".concat(Config.baseURL, "JobCardDetail/GetPartDetails");
/****************** CustomerVoice ***************************/
export var customerVoiceCVTypeListURL = "".concat(Config.baseURL, "CVType/List");
export var customerVoiceFromListURL = "".concat(Config.baseURL, "CustomerVoiceFrom/List");
export var complaintTypeGetComplaintsURL = "".concat(Config.baseURL, "ComplaintType/GetComplaints");
export var complaintSubCategoryURL = "".concat(Config.baseURL, "SubCategory/List");
/*********************warranty grid pick list url*********************************/
export var warrantyServiceTypeListURL = "".concat(Config.baseURL, "ServiceType/ServiceTypeList");
export var warrantyCasualFlagListURL = "".concat(Config.baseURL, "CasualFlag/List");
export var GetOrganizationTypeListURL = "".concat(Config.baseURL, "Organization/GetOrganizationTypeList");
export var warrantyComplaintTypeGetComplaintsURL = "".concat(Config.baseURL, "ComplaintType/GetComplaints");
export var warrantyGetPartDetailsURL = "".concat(Config.baseURL, "JobCardDetail/GetPartDetails");
export var pauseReasonListAPIUrl = "".concat(Config.baseURL, "Reason/GetPauseReasonList");
/**********************Labour Grid (Service Grid )***************************/
export var LabourListURL = "".concat(Config.baseURL, "Labour/List");
export var WorkPurchaseOrderListURL = "".concat(Config.baseURL, "WorkPurchaseOrder/WorkPurchaseOrderList");
export var ValidateDeletePartLabourUrl = "".concat(Config.baseURL, "JobCardDetail/ValidateLineLevelDeletion");
export var GridValidations = {
    WORK_COMPLETED: 'You cannot edit labour since work has completed.',
    LABOUR_PAUSED: 'You cannot edit labour since labour is paused.',
    LABOUR_AWAITING: 'You cannot edit date time since labour is awaiting.',
    SAC_REQUIRED: 'SAC code is mandatory to perform an action on labour.',
    TECHNICIAN_REQUIRED: 'Please select technician before starting the work.',
    DATE_VALIDATION: 'You cannot enter end date time as work status is started.',
    MECHANIC_NOT_ALLOCATED: "You cannot change status of 'Labour' since 'Technician' is not allocated.",
    JOB_TYPE_REQUIRED: "You cannot leave job type blank since job type is required."
};
export var MANDATORY_FIELDS = {
    'TechnicianName': 'TechnicianName',
    'ServiceTypeName': 'ServiceTypeName'
    // 'PauseRemarks': 'PauseRemarks',
};
